import { PurchaseErrorCodeKeys } from '~/purchase/types';
import { CommonErrorCodes, PurchaseErrorCodes } from '~/common/helpers';
import { TranslationKeys } from '~/common/types';
import { REQUIRED_MESSAGE } from '@wyz/utils';

const i18nProxyHandler = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(target: object, propertyKey: PropertyKey, receiver?: any) {
    const value = Reflect.get(target, propertyKey, receiver);
    if (value === undefined) return 'app.common.messages.error';
    return value;
  },
};
export const PurchaseErrorCodesLookup = new Proxy<
  // todo merge all errors in one lookups
  Record<
    | PurchaseErrorCodeKeys
    | 'ERR_VALUE_SHOULD_NOT_BE_BLANK'
    | 'ERR_VALUE_SHOULD_BE_POSITIVE'
    | 'ERR_VALIDATION',
    keyof TranslationKeys
  >
>(
  {
    [PurchaseErrorCodes.ERR_OBSOLETE_CART]: 'app.purchase.cart.errors.changes',
    [PurchaseErrorCodes.ERR_TECHNICAL_ISSUE]:
      'app.purchase.cart.errors.unavailable',
    [PurchaseErrorCodes.ERR_QUANTITY_0]: 'app.purchase.cart.errors.unavailable',
    [PurchaseErrorCodes.ERR_CART_EMPTY_QUANTITY]:
      'app.purchase.cart.errors.available_quantity',
    [PurchaseErrorCodes.ERR_QUANTITY_CHANGED]:
      'app.purchase.cart.errors.invalid_stock',
    [PurchaseErrorCodes.ERR_DELIVERY_DATE_CHANGED]:
      'app.purchase.cart.errors.invalid_date',
    [PurchaseErrorCodes.ERR_PRICE_CHANGED]:
      'app.purchase.cart.errors.invalid_price',
    [PurchaseErrorCodes.ERR_CUSTOMER_BRAND_NOT_FOUND]:
      'app.purchase.search_page.errors.missing_brands',
    [PurchaseErrorCodes.ERR_CUSTOMER_CONFIGURATION_NOT_FOUND]:
      'app.purchase.search_page.errors.missing_configuration',
    [PurchaseErrorCodes.ERR_TENANT_SETTINGS_NOT_FOUND]:
      'app.purchase.search_page.errors.missing_settings',
    [PurchaseErrorCodes.ERR_MAX_SEARCH_RESULT_EXCEEDED]:
      'app.purchase.search_page.search_max_count',
    [PurchaseErrorCodes.ERR_OFFER_REPLACED]:
      'app.purchase.cart.errors.invalid_stock',
    [PurchaseErrorCodes.ERR_INVALID_CART]:
      'app.purchase.search_page.errors.validation',
    [PurchaseErrorCodes.ERR_ACCEPT_ORDER_DATA_CHANGED]:
      'app.purchase.cart.errors.changes',
    [PurchaseErrorCodes.ERR_ACCEPT_EMPTY_QUANTITY]:
      'app.purchase.redistribution.order_accept.errors.empty_quantity',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_EMPTY_EAN]:
      'import.container_pricing_policies.empty_ean',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_EXISTING_EAN]:
      'import.container_pricing_policies.existing_ean',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_INVALID_PRICE]:
      'import.container_pricing_policies.invalid_price',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_EAN_NOT_FOUND]:
      'import.container_pricing_policies.ean_not_found',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_TOO_FEW_COLUMNS]:
      'import.container_pricing_policies.too_few_columns',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_EMPTY_POLICY_NAME]:
      'import.container_pricing_policies.empty_policy_name',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_INVALID_CURRENCY]:
      'import.container_pricing_policies.invalid_currency',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_INVALID_INCOTERM]:
      'import.container_pricing_policies.invalid_incoterm',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_EXISTING_POLICY_NAME]:
      'import.container_pricing_policies.existing_policy_name',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_OVERLAP]:
      'import.container_pricing_policies.policy_overlap',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_FILE_PARSE_ERROR]:
      'import.container_pricing_policies.upload_error',
    [PurchaseErrorCodes.CONTAINER_PRICING_POLICY_FILE_UPLOAD_ERROR]:
      'import.container_pricing_policies.upload_error',
    [PurchaseErrorCodes.ERR_CART_MODIFIED_BY_ANOTHER_PROCESS]:
      'app.purchase.cart.errors.modified_by_another_process',
    [PurchaseErrorCodes.ERR_CONTAINER_OFFER_PRICING_POLICIES_NOT_FOUND]:
      'app.container.order.errors.container_pricing_policies_not_found',
    [PurchaseErrorCodes.ERR_CONTAINER_OFFER_INVALID_FILL_RATE]:
      'app.container.order.errors.invalid_fill_rate',
    [PurchaseErrorCodes.ERR_CONTAINER_INVALID_REQUEST_ENTRIES]:
      'app.container.order.errors.invalid_request_entries',
    [PurchaseErrorCodes.ERR_CONTAINER_EAN_NOT_IN_CATALOG]:
      'app.container.order.errors.ean_not_in_catalog',
    [PurchaseErrorCodes.ERR_CONTAINER_EAN_NO_PRICING_POLICY]:
      'app.container.order.errors.ean_no_pricing_policy',
    [PurchaseErrorCodes.ERR_CONTAINER_EAN_REDUNDANT]:
      'app.container.order.errors.ean_redundant',
    [CommonErrorCodes.ERR_VALUE_SHOULD_NOT_BE_BLANK]: REQUIRED_MESSAGE,
    [CommonErrorCodes.ERR_VALUE_SHOULD_BE_POSITIVE]:
      'app.common.validations.positive_number',
    [CommonErrorCodes.ERR_VALIDATION]: 'app.common.validations.error_message',
    [PurchaseErrorCodes.ERR_GET_STOCK_PRICE_SERVER_ERROR]:
      'app.purchase.cart_page.server_error',
    [PurchaseErrorCodes.ERR_GET_STOCK_PRICE_TIMEOUT]:
      'app.purchase.cart_page.timeout_error',
    [PurchaseErrorCodes.ERR_CONTAINER_IMPORT_INVALID_QUANTITY]:
      'app.common.assert.field_should_be_number',
    [PurchaseErrorCodes.ERR_CONTAINER_IMPORT_EMPTY_EAN]:
      'app.common.assert.field_required',
    [PurchaseErrorCodes.ERR_CONTAINER_IMPORT_EMPTY_QUANTITY]:
      'app.common.assert.field_required',
    [PurchaseErrorCodes.ERR_CONTAINER_IMPORT_EMPTY_NUMBER]:
      'app.common.assert.field_required',
    [PurchaseErrorCodes.ERR_CONTAINER_IMPORT_INVALID_CONTAINER_ID]:
      'app.container.order.errors.invalid_container_id',
    [PurchaseErrorCodes.ERR_CONTAINER_TRANSPORT_ITEM_UPDATE_NOT_ALLOWED]:
      'app.container.order.errors.transport_item_update_not_allowed',
    [PurchaseErrorCodes.ERR_CONTAINER_TRANSPORT_ITEM_TRANSITION_NOT_ALLOWED]:
      'app.container.order.errors.transport_item_transition_not_allowed',
  },
  i18nProxyHandler,
);
